import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { DMSIDS } from "models";

import type { DealerDMSCarITConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type CarITConfig = Pick<DealerDMSCarITConfig, "import_offers" | "internal_orders" | "internal_customer_group_ids" | "api_base_url" | "user_name" | "password">;

type CarITConfigSectionProps = {
  dmsId: DMSIDS;
};

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const CarITConfigSection = ({ dmsId }: CarITConfigSectionProps) => {
  const { t } = useTranslation();

  const isCarItHybrid = DMSIDS.CARIT_HYBRID === dmsId;

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_internal_customer_group_ids", "Internal customer group ids")} </label>
            <FormHelper.Field.Input name="carit_config.internal_customer_group_ids" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        {isCarItHybrid && (
          <GridColumn>
            <Form.Field>
              <label>{t("v8_api_base_url", "API Base URL")} </label>
              <FormHelper.Field.Input name="carit_config.api_base_url" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>
        )}
      </Grid>

      {isCarItHybrid && (
        <Grid columns="equal">
          <GridColumn>
            <Form.Field>
              <label>{t("v8_username", "Username")} </label>
              <FormHelper.Field.Input name="carit_config.user_name" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_password", "Password")} </label>
              <FormHelper.Field.Input name="carit_config.password" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_import_offers", "Import offers")} </label>
              <FormHelper.Field.Checkbox name="carit_config.import_offers" checkboxProps={{ toggle: true, fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_import_internal_orders", "Import internal orders")} </label>
              <FormHelper.Field.Checkbox name="carit_config.internal_orders" checkboxProps={{ toggle: true, fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>
      )}
    </>
  );
};
